<template>
  <div
    class="guide-tip-wrapper"
    :class="`${createRenderType}-guide-tip-wrapper`"
    ref="guideTipRef"
  >
    <div class="click-img">
      <img src="@/assets/img/click-ico.png" alt="" />
    </div>
    <div class="click-text tc">{{ $$t("create.explore_models") }}</div>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useModelDataStore from "@/store/model/modelDataStore.js";

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const { $$t } = globalProperties?.$i18n;
const createLayoutStore = useCreateLayoutStore();
const modelDataStore = useModelDataStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const guideTipRef = ref(null);

// 点击外部隐藏元素的逻辑
const handleClickOutside = (event) => {
  if (guideTipRef.value && !guideTipRef.value.contains(event.target)) {
    modelDataStore.updataChooseModelPop(); // 隐藏元素
  }
};

// 监听全局点击事件
onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

// 组件卸载时移除事件监听
onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});
</script>

<style lang="scss" scoped>
.guide-tip-wrapper {
  border-radius: 12px;
  z-index: 100;
  .click-img {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%) translateY(-24px);
    img {
      width: 40px;
      height: 40px;
      display: block;
    }
  }
  .click-text {
    border-radius: 12px;
    padding: 18px;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: #fff;
    background: #94adff;
  }
}
.mobile-guide-tip-wrapper {
  width: 150px;
  position: absolute; /* 绝对定位 */
  top: 50%; /* 相对于父元素顶部 50% */
  left: 50%; /* 相对于父元素左侧 50% */
  transform: translate(-50%, 36px); /* 自身宽高的一半偏移 */
  .click-img {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%) translateY(-28px);
    img {
      width: 35px;
      height: 40px;
      display: block;
    }
  }
  .click-text {
    padding: 6px;
  }
}
</style>